import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../../mutation-types';
import stockistAPI from '../../../../api/stockist';
import alertHelper from '../../../../helpers/alert';

const defaultState = () => ({
	allStockist: [],
	stockistOne: {},
	alert: [],
	provinces: [],
	cities: [],
	subdistricts: [],
	pagination:{},
});

const state = defaultState();

const mutations = {
	defineAllStockist(state, data) {
		if (data.code == 'all') {
			state.allStockist = data.data
		} else if (data.code == 'more'){
			state.allStockist.push(...data.data)
		}
		state.pagination = data.pagination
	},
	listMoreAllStockist(state, data) {
		state.allStockist.push(...data)
	},
	listProvince(state, data) {
		state.provinces = data;
	},
	listCity(state, data) {
		state.cities = data.map(el => {
			el.city_type_name = el.type + ' ' + el.city_name
			return el
		});
	},
	listSubdistricts(state, data) {
		state.subdistricts = data;
	},
	defineStockistOne(state, data) {
		state.stockistOne = Object.assign({}, state.stockistOne, data);
	},
	failed(state, { code, type, message }) {
		state.alerts = alertHelper.make(state.alerts, code, type, message);
	},
	reset(state) {
		Object.assign(state, defaultState());
	},
};

const actions = {
	getAllStockist({ commit, dispatch }, params) {
		commit(PROGRESS_START, null, { root: true });
		commit('defineAllStockist', {code: 'all', data: [], pagination: 0});
		stockistAPI.list(params).then(({ data: { data } }) => {
			if (data) {
				if (data.results.length > 0) {
					commit('defineAllStockist', {code: 'all', data: data.results, pagination: data.pagination});
				} else {
					commit('defineAllStockist', {code: 'all', data: 'error', pagination: 0});
				}
			} else {
				commit('defineAllStockist', {code: 'all', data: 'error', pagination: 0});
			}
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			commit('stockist/defineAllStockist', {code: 'all', data: 'error', pagination: 0}, { root: true });
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	getMoreAllStockist({ commit, dispatch }, params) {
		commit(PROGRESS_START, null, { root: true });
		let parameterObject = {}
		let api = 'list'
		let parameter = '{';
		params.filter.forEach((value, index) => {
			for (const [key, val] of Object.entries(value)) {
				parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`
			}
		})
		if (params.product_code) {
			parameter += `"product_code": "${params.product_code}", `;
			api = 'listByProduct'
		}
		parameter += `"limit": ${params.limit}, "page": ${params.page}, "lat": ${params.lat}, "lng": ${params.lng}}`;
		parameterObject = JSON.parse(parameter);
		stockistAPI[api](parameterObject).then(({ data: { data } }) => {
			commit('defineAllStockist', {code: 'more', data: data.results, pagination: data.pagination});
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	getStockistByProduct({ commit, dispatch }, params) {
		commit(PROGRESS_START, null, { root: true });
		commit('defineAllStockist', {code: 'all', data: [], pagination: 0});
		stockistAPI.listByProduct(params).then(({ data: { data } }) => {
			if (data) {
				if (data.results.length > 0) {
					commit('defineAllStockist', {code: 'all', data: data.results, pagination: data.pagination});
				} else {
					commit('defineAllStockist', {code: 'all', data: 'error', pagination: 0});
				}
			} else {
				commit('defineAllStockist', {code: 'all', data: 'error', pagination: 0});
			}
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			commit('stockist/defineAllStockist', {code: 'all', data: 'error', pagination: 0}, { root: true });
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	getStockistDetail({ state, commit, dispatch }, code) {
		if (code === state.stockistOne.stockist_network_id) {
			return;
		} else {
			commit(PROGRESS_START, null, { root: true });

			stockistAPI.detail(code).then(({ data: { data } }) => {
				commit('defineStockistOne', data);
				commit(PROGRESS_FINISH, null, { root: true });
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				commit(PROGRESS_FAIL, null, { root: true });
			});
		}
	},
	getStockistByProvince({ commit, dispatch }) {
		commit(PROGRESS_START, null, { root: true });
		stockistAPI.province().then(({ data: { data: { results } } }) => {
			commit('listProvince', results);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	getCity({ commit, dispatch }, params) {
		commit(PROGRESS_START, null, { root: true });
		stockistAPI.city(params).then(({ data: { data: { results } } }) => {
			commit('listCity', results);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	getSubdisctrict({ commit, dispatch }, params) {
		commit(PROGRESS_START, null, { root: true });
		stockistAPI.subdistrict(params).then(({ data: { data: { results } } }) => {
			commit('listSubdistricts', results);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	search({ commit, dispatch }, params) {
		commit(PROGRESS_START, null, { root: true });
		commit('defineAllStockist', {code: 'all', data: [], pagination: 0});
		let api = 'list'
		let parameterObject = {}
		let parameter = '{'
		if (params.filter.length > 0) {
			params.filter.forEach((value, index) => {
				for (const [key, val] of Object.entries(value)) {
					parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`
				}
			})
			parameter = parameter.slice(0, -1)
			parameter += `,`
		}
		if (params.product_code) {
			parameter += `"product_code": "${params.product_code}", `;
			api = 'listByProduct'
		}
		parameter += `"lat": ${params.lat}, "lng": ${params.lng}}`
		parameterObject = JSON.parse(parameter)
		stockistAPI[api](parameterObject)
		.then(({ data: { data } }) => {
			if (data) {
				if (data.results.length > 0) {
					commit('defineAllStockist', {code: 'all', data: data.results, pagination: data.pagination});
				} else {
					commit('defineAllStockist', {code: 'all', data: 'error', pagination: 0});
				}
			} else {
				commit('defineAllStockist', {code: 'all', data: 'error', pagination: 0});
			}
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			commit('stockist/defineAllStockist', {code: 'all', data: 'error', pagination: 0}, { root: true });
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},

	errorHandler({ commit }, response) {
		commit('failed', { code: 'error_response', type: 'error', message: response.message });
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};